// src/components/Toast.js
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,    
  showCloseButton: true,      
  timer: 10000,            
  timerProgressBar: true,      
  showClass: {
    popup: "swal2-noanimation",
    backdrop: "swal2-noanimation",
  },
  hideClass: {
    popup: "",
  },
});

export default Toast;
